import { render, staticRenderFns } from "./CarfaxModal.vue?vue&type=template&id=90ed4e52&"
import script from "./CarfaxModal.vue?vue&type=script&lang=js&"
export * from "./CarfaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports